import { RPerteChargeAccidentSchema_Type } from '@batical/types/src'

import { fetchGeneric, fetchGenericSorted } from './GenericQ'

const RPerteChargeAccident: Array<RPerteChargeAccidentSchema_Type> = require('../json/PerteChargeAccident.json')
//RPerteChargeAccident
export function fetchPerteChargeAccidentSorted(): Array<{
  value: string
  label: string
}> {
  return fetchGenericSorted(RPerteChargeAccident)
}

export function fetchPerteChargeAccident(uuid: string): RPerteChargeAccidentSchema_Type {
  return fetchGeneric(RPerteChargeAccident, uuid)
}
